<template>
  <v-dialog
    class="dialog-box-custom"
    content-class="dialog-box-custom-content"
    v-model="isOpen"
    width="18.2rem"
    :persistent="isPersistent"
    @keydown.prevent.enter="executeMainAction"
  >
    <v-card
      :style="{ padding: '0', borderRadius: '0.75rem !important'}"
    >
      <div class="icon-box-custom">
        <v-icon x-large :color="iconColor">{{ icon }}</v-icon>
      </div>

      <div class="text-box-custom">
        <span class="title-text-custom">{{ title }}</span>
        <span :style="paddingStyle" class="content-text-custom">{{ content }}</span>
        <span v-if="extraContent" :style="extraContentStyle" class="content-text-custom">{{ extraContent }}</span>
      </div>

      <v-card-actions class="buttons-div-custom">
        <v-btn
          v-if="secondaryActionDisable"
          @click="executeSecondaryAction"
          :ripple="false"
          :class="{ 'secondary-button-custom-delete': isDeleteDialog, 'secondary-button-custom': !isDeleteDialog }"
          text
          :loading="loading"
        >
          {{ secondaryActionLabel }}
        </v-btn>
        <v-btn
          @click="executeMainAction"
          :ripple="false"
          :class="{ 'main-button-custom-delete': isDeleteDialog, 'main-button-custom': !isDeleteDialog }"
          text
          :disabled="loading"
        >
          {{ mainActionLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogChoice",

  props: {
    /**
     * Defines if the dialog box is open or not.
     */
    isOpen: {
      type: Boolean,
      required: true,
    },
    /**
     * Title of the dialog box.
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * Main text inside the dialog box
     */
    content: {
      type: String,
      required: true,
    },
    /**
     * Main text inside the dialog box
     */
     extraContent: {
      type: String,
      required: false,
    },

    extraContentStyle:{
      type: Object,
      default: {
        'font-weight': '1000!important',
        'font-size': '0.8rem !important',
      },
    },
    /**
     * Label of the main action button
     */
    mainActionLabel: {
      type: String,
      required: true,
    },
    /**
     * Label of the secondary action button
     */
    secondaryActionLabel: {
      type: String,
      required: true,
    },

    /**
     * Defines if the dialog box can be closed by clicking outside of it
     */
    isPersistent: {
      type: Boolean,
      default: true,
    },

    /**
     * Determines if the second button is loading and the main one is disabled
     */
    loading: {
      type: Boolean,
      default: false,
    },

    /**
     * Determines if the secondary button is disabled
     */
    secondaryActionDisable: {
      type: Boolean,
      default: true,
    },

    /**
     * Icon of dialog box
     */
    icon: {
      type: String,
      required: true,
    },

    /**
     * Color of Icon
     */
    iconColor: {
      type: String,
      required: true,
    },
    
    isDeleteDialog: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {

    };
  },
  
  computed: {
    paddingStyle(){
      return this.extraContent ? {'padding-bottom': '0!important'} : { }
    }
  },

  watch: {

  },

  methods: {
    /**
     * Send an event to the parent to execute the main action.
     */
    executeMainAction() {
      this.$emit("mainAction");
    },
    /**
     * Send an event to the parent to execute the secondary action.
     */
    executeSecondaryAction() {
      this.$emit("secondaryAction");
    },
  },
};
</script>

<style>
.dialog-box-custom {
  display: inline-flex;
  padding-top: 17.167px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.26825rem;
  border-radius: 0.75rem !important;
}

.icon-box-custom {
  padding-top: 1.1rem;
}

.text-box-custom {
  padding: 0.3rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.title-text-custom {
  color: #231e46 !important;
  font-feature-settings: "clig" off, "liga" off !important;
  font-size: 0.9375rem !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 1.47531rem !important;
  font-family: Lato !important;
  text-transform: uppercase;
}

.content-text-custom {
  display: block !important;
  padding-bottom: 1.1rem !important;
  color: #231e46 !important;
  text-align: center !important;
  font-feature-settings: "clig" off, "liga" off !important;
  font-family: Lato !important;
  font-size: 0.78125rem !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 1.20706rem !important;
  max-width: 16rem;
}

.buttons-div-custom {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 3rem;
  padding: 0 !important;
}

.main-button-custom, .main-button-custom-delete {
  flex: 2;
  border-radius: 0;
  margin: 0 !important;
  padding: 0 !important;
  flex-grow: 1 !important;
  height: 3rem !important;
  color: #29bdf0 !important;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Lato !important;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.47531rem;
  text-transform: none;
  border-top: 0.357px solid #DBDBE0;
}

.main-button-custom:hover {
  background-color: #29bdf0 !important;
  color: #ffffff !important;
  border-radius: 0 0 0.75rem 0 !important;
}

.secondary-button-custom, .secondary-button-custom-delete{
  flex: 2;
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  flex-grow: 1 !important;
  height: 3rem !important;
  color: #29bdf0 !important;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Lato !important;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.47531rem;
  text-transform: none;
  border-top: 0.357px solid #DBDBE0;
  border-right: 0.1785px solid #DBDBE0;
}

.main-button-custom-delete, .secondary-button-custom-delete{
  color: #FF0000 !important;
}

.secondary-button-custom:hover {
  background-color: #29bdf0;
  color: #ffffff !important;
  border-radius: 0 0 0 0.75rem !important;
}
.secondary-button-custom-delete:hover {
  background-color: #FF0000;
  color: #ffffff !important;
  border-radius: 0 0 0 0.75rem !important;
}

.main-button-custom-delete:hover {
  background-color: #FF0000 !important;
  color: #ffffff !important;
  border-radius: 0 0 0.75rem 0 !important;
}

.dialog-box-custom-content.v-dialog {
  border-radius: 0.75rem !important;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/_Molecules/DialogChoice.vue